import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import type { ReactNode } from "react";

export function TextLink({
  href,
  children,
}: {
  href: string;
  children: ReactNode;
}) {
  return (
    <Link
      to={href}
      className="inline-flex items-center gap-1.5 text-slate-700 font-medium hover:text-slate-900 dark:text-slate-300 dark:hover:text-slate-100"
    >
      {children}
      <ChevronRight className="h-4 w-4" />
    </Link>
  );
}
